"use client";

import { NormalBrowseFileInputFiled, NormalTextInputField } from "@/components";

const NewsAndBlogsHeroSection = ({
  isFetching,
  stateDetails,
  handleTextInputChange,
  allFilesResponse,
  searchValue,
  selectedFileType,
  onChangeImage,
  adminRole,
  permissionsList,
}) => {
  const getSelectedBannerImageId = (id) => {
    if (id) {
      onChangeImage("news-and-blogs-section-1-banner-image", id);
    } else {
      onChangeImage("news-and-blogs-section-1-banner-image", "");
    }
  };

  return (
    <>
      {/* Tag Name */}
      <NormalTextInputField
        isFetching={isFetching}
        labelText="Title"
        fieldId="news-and-blogs-section-1-title"
        fieldName="news-and-blogs-section-1-title"
        placeholderText="Tag Title"
        inputValue={stateDetails?.["news-and-blogs-section-1-title"] || ""}
        onChangeTextInputField={handleTextInputChange}
        extraFiledInfo="Section tag name."
        translateField={true}
      />

      {/* Heading */}
      <NormalTextInputField
        isFetching={isFetching}
        labelText="Heading"
        fieldId="news-and-blogs-section-1-heading"
        fieldName="news-and-blogs-section-1-heading"
        placeholderText="Heading"
        inputValue={stateDetails?.["news-and-blogs-section-1-heading"] || ""}
        onChangeTextInputField={handleTextInputChange}
        extraContainerClasses="mt-5"
        translateField={true}
      />

      {/* SubHeaing */}
      <NormalTextInputField
        isFetching={isFetching}
        isTextArea={true}
        labelText="Sub Heading"
        fieldId="news-and-blogs-section-1-sub-heading"
        fieldName="news-and-blogs-section-1-sub-heading"
        placeholderText="Sub Heading"
        inputValue={
          stateDetails?.["news-and-blogs-section-1-sub-heading"] || ""
        }
        onChangeTextInputField={handleTextInputChange}
        extraContainerClasses="mt-5"
        translateField={true}
      />

      {/* Banner Image */}
      <NormalBrowseFileInputFiled
        isFetching={isFetching}
        labelText="Banner Image"
        fieldId="news-and-blogs-section-1-banner-image"
        allFilesResponse={allFilesResponse}
        searchValue={searchValue}
        selectedFileType={selectedFileType}
        onChangeImageFunction={getSelectedBannerImageId}
        selectedFileId={
          stateDetails?.["news-and-blogs-section-1-banner-image"] || ""
        }
        adminRole={adminRole}
        permissionsList={permissionsList}
        infoText="Recommended size: 1300 x 650px"
        extraContainerClasses="mt-5"
      />
    </>
  );
};

export default NewsAndBlogsHeroSection;
